import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getMomentTZDateTime } from 'ts-util';
import TranslatorManager from 'ts-translate-js';
const tr = TranslatorManager.boundTR;

export function ScheduleRangeSelectorInfo({scheduleRange, eventDate, buttonClasses, onModifyThisStep, onContentChange}) {
    useEffect(() => {
        if(onContentChange) onContentChange();
    });

    const dateDisplayFormat = (dateValue, TZ) => {
        const formatStr = tr("D MMMM YYYY");
        const dateToDisplay = getMomentTZDateTime(dateValue, TZ.TZDatabaseID).format(formatStr);
        return dateToDisplay;
    };

    let scheduleRangeSelectionInfo = null;

    if (scheduleRange) {
        const dateValueText = dateDisplayFormat(scheduleRange.ValidDate, eventDate.TimeZone);
        const rangeValueText = scheduleRange.StartTime + " " + tr("à") + " " + scheduleRange.EndTime;
        
        scheduleRangeSelectionInfo = (
            <div>
                <ul className="list-inline">
                    <li><strong>{tr("Votre sélection :")}</strong> {dateValueText} - {rangeValueText}</li>
                    <li><button className={buttonClasses} type="button" onClick={onModifyThisStep}>{tr("Changer")}</button></li>
                </ul>                    
            </div>);
    }

    return (<div>
        {scheduleRangeSelectionInfo}
    </div>);
}

ScheduleRangeSelectorInfo.propTypes = {
    scheduleRange: PropTypes.object,
    eventDate: PropTypes.object,
    buttonClasses: PropTypes.string,
    onModifyThisStep: PropTypes.func,
    onContentChange: PropTypes.func,
};